module.exports = __webpack_public_path__ + "static/media/teammember2.c7509617.png";